import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { User } from '../../models/user';
import { NO_PARTNER_ACCESS, PartnerAccess, partnerAccess } from '../../../features/partner/access/partner-access';

@Injectable({ providedIn: 'root' })
export class PartnerAccessService {
  private readonly http = inject(HttpClient);
  private readonly user = inject(User);
  private loaded: { session: string; request: Promise<PartnerAccess> } | null = null;

  /** GET /v1/partner-portal/access/. Asked once per sign-in; a failed request is retried next time. */
  load(): Promise<PartnerAccess> {
    const session = this.user.access_token;
    if (!session) {
      this.loaded = null;
      partnerAccess.set(NO_PARTNER_ACCESS);
      return Promise.resolve(NO_PARTNER_ACCESS);
    }
    if (this.loaded?.session !== session) {
      partnerAccess.set(NO_PARTNER_ACCESS);
      const request = firstValueFrom(
        this.http.get<PartnerAccess>(`${environment.apiUrl}/v1/partner-portal/access/`)
      ).then(
        (access) => {
          partnerAccess.set(access);
          return access;
        },
        () => {
          this.loaded = null;
          return NO_PARTNER_ACCESS;
        }
      );
      this.loaded = { session, request };
    }
    return this.loaded.request;
  }
}
